define('wanewsletter', ['jquery'], function ($) {

    return {
        newsletterFooter: $('.footer__newsletter'),
        newsletterBar: $('.newsletter__bar'),
        newsletterBarClose: $('#js_newsletterBarClose'),
        newsletterBarItem: $('#js_newsletterBarItem'),
        newsletterForm: $('form.newsletter__formular'),
        newsletterFormContainer: $('#js_newsletterForm .newsletter'),
        newsletterModalLink: $('[href="/?cl=newsletter"]'),
        newsletterModalForm: $('.newsletter__modal'),
        initialzeBar: function initialzeBar() {
            if (this.newsletterFooter) {
                this.displayBar(true);
                this.bindEvents();
            }
        },
        displayBar: function displayBar(display) {
            !!display && !window.localStorage.nlbar ? this.newsletterBar.addClass('show') : this.newsletterBar.removeClass('show');
        },
        bindEvents: function bindEvents() {
            var _this = this;

            //scroll to footer
            this.newsletterBarItem.on('click', function (e) {
                _this.newsletterFormContainer.html(_this.newsletterForm.clone(true, true)) && _this.newsletterFormContainer.trigger('click');
            });

            //close newsletter bar
            this.newsletterBarClose.on('click', function (e) {
                _this.displayBar(false);
                window.localStorage.nlbar = 0;
            });
        },
        newsletterModal: function newsletterModal() {
            var _this2 = this;

            this.newsletterModalLink.on('click', function (e) {
                e.preventDefault();
                _this2.newsletterModalForm.fadeIn();
            });
        },
        init: function init() {
            this.initialzeBar();
            this.newsletterModal();
        }
    };
});

